<template>
  <div id="exam">
    <router-view v-if="this.$route.path != '/courseContent/Exam'" />
    <div class="nav" style="height:104%;  position: relative;" v-else>
      <div class="nav-header">
        <li>
          <one-button @click="AddTest">
            <span class="iconfont icon-jiahao" />
            {{ $t('translateText.Exam.xjsj') }}</one-button
          >
          <one-button @click="addExam">
            <span class="iconfont icon-jiahao" />
            {{ $t('translateText.Exam.sjk') }}</one-button
          >
          <one-button @click="delFn">
            <span class="iconfont icon-shanchu1" />
            {{ $t('translateText.Exam.plsc') }}</one-button
          >
        </li>
        <li style="width: 20%">
          <search
            :placeholder="$t('translateText.Exam.qsrsjm')"
            @search="onSearch"
            @zero="zero"
          />
        </li>
      </div>
      <div class="nav-body" ref="body">
        <test
          :columns="columns"
          :data2="data"
          :edit1="edit"
          :del="delete1"
          :submit="submit1"
          :addto="addto"
          :title="$t('translateText.Exam.qrsc')"
          v-on:update="compile"
          v-on:submitDetail="openSubmitDetails"
          @scope="del"
          @checkAll="checkAll"
          @addreceive="addreceive"
          :Show="true"
          :height="{ y: 420 }"
        ></test>
      </div>
      <div class="nav-footer">
        <pag ref="Exampag" @passpage="passpage" />
      </div>
      <s-modal :visible="svisible" @cancel="cancelFn" @confirm="confirmFn">
        {{ $t('translateText.Exam.qrscm') }}
      </s-modal>
      <!-- 新建作业 -->
      <a-modal
        :visible="addExamDiv"
        :footer="null"
        width="680px"
        @cancel="handleCancel"
      >
        <div>
          <p class="addExamDivTitle">{{ addExamDivTitle }}</p>
          <selectExamination
            ref="selectExamination"
            v-show="showExamList"
            :examinationColumns="examinationColumns"
            :examinationList="examinationList"
            :Show="true"
            v-on:getExaminationId="getExaminationId"
          ></selectExamination>
          <selectUser
            ref="selectuser"
            v-show="showAddExamUser"
            :ClassListColumns="ClassListColumns"
            :ClassList="ClassList"
            :ShowClass="true"
            :UserListColumns="UserListColumns"
            :UserList="UserList"
            :ShowUser="true"
            v-on:getExaminationRelease="getExaminationRelease"
            v-on:getReceiveList="getReceiveList"
          ></selectUser>
          <div class="addExamDivFooter">
            <button @click="cancelButton($event)">
              {{ addExamDivCancelText }}
            </button>
            <button @click="okButton" class="okButton">
              {{ addExamDivOkText }}
            </button>
          </div>
        </div>
      </a-modal>
      <!-- 追加发放 -->
      <a-modal :visible="isaddto" :footer="null" width="680px" @cancel="cancel">
        <search
          style="margin: 10px 0px; width: 30%"
          :placeholder="$t('translateText.Exam.qsrsjm')"
          @search="Searchuser"
          @zero="zero"
        />
        <test
          :columns="UserListColumns"
          :data2="userarr"
          :Show="true"
          :height="{ y: 300 }"
          @usercheckAll="usercheckAll"
        >
        </test>
        <div class="addExamDivFooter">
          <button @click="cancel">{{ $t('translateText.cancel') }}</button>
          <button @click="confirm" class="okButton">
            {{ $t('translateText.ok') }}
          </button>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
const moment = require('moment')
import search from '@/components/search' //搜索组件
import pag from '@/components/pagiation' //分页组件
import test from '@/components/Table/Table' //表单组件
import sModal from '@/components/Modal/secondModal' //对话框modal
import selectExamination from '@/components/Table/SelectExamination' //试卷表
import selectUser from '@/components/Table/SelectUser' //选择发布用户
import { mapState } from 'vuex'
import {
  getExamination,
  deleteExaminationRelease,
  getpublishedwork,
  releaseExamination,
  getExaminationInfo,
  getStudentByCourse,
  addtoreleaseExamination,
} from '@/utils/api'
export default {
  data() {
    return {
      iExamReleaseId: '',
      strRealName: '',
      selectedusers: [],
      userarr: [],
      isaddto: false,
      Receiveinfo: [], //发布信息
      isadd: true,
      pageNumber: '1',
      showTotal: null,
      svisible: false,
      edit: this.$t('translateText.Exam.Edit'),
      delete1: this.$t('translateText.Exam.Delete'),
      submit1:this.$t('translateText.Exam.tjxq'),
      addto: this.$t('translateText.Exam.zjff'),
      addExamDiv: false,
      showExamList: true,
      showAddExamUser: false,
      // colorAdd: false,
      // colorNew: false,
      // colorDel: false,
      addExamDivTitle:  this.$t('translateText.Exam.sjk'),
      addExamDivOkText: this.$t('translateText.Exam.xyb'),
      addExamDivCancelText: this.$t('translateText.cancel'),
      // bodyHeight: 0,
      examinationRelease: null,
      selectedRowKeys: '', //选择列表
      showuser: [],
      searchKey: '',
      examinationIdList: [],
      starttime: '', //开始时间
      endtime: '', //结束时间
      passingscore: '', //及格分数线
      goodscore: '', //良好分数线
      excellentscore: '', //优秀分数线
      stickup: '', //是否允许粘贴
      outorder: '', //是否乱序
      viewscore: '', //学生是否可查看成绩
      releaseobj: [], //发放对象
      releasetype: '',
      ReceiveList: [], //接受列表
      ReceiveclassList: [], //接受班级列表
      updateData: '', //点击编辑的数据
      data: [],

      examinationList: [],
      ClassList: [],
      UserList: [],
    }
  },
  mounted() {
    // this.bodyHeight = this.$refs.body.offsetHeight - 60;
    this.courseid = localStorage.getItem('courseId')
    this.getpublishedexam()
    this.getexamination()
    this.$EventBus.$on('updateExamina', () => {
      this.getpublishedexam()
    })
  },
  computed: {
    selectedRowKey() {
      return this.selectedRowKeys.length > 0
    },
    search() {
      return this.searchKey.length
    },
    ...mapState(['questiontypes']),
    examinationColumns() {
      return [
        {
          title: this.$t('translateText.Exam.sjm'),
          dataIndex: 'strExaminationName',
        },
      ]
    },
    ClassListColumns() {
      return [
        {
          title: this.$t('translateText.Exam.bj'),
          dataIndex: 'strClassName',
        },
      ]
    },
    UserListColumns() {
      return [
        {
          title: this.$t('translateText.Exam.xh'),
          dataIndex: 'strUserName',
        },
        {
          title: this.$t('translateText.Exam.xm'),
          dataIndex: 'strRealName',
        },
      ]
    },
    columns() {
      return [
        {
          title: this.$t('translateText.Exam.xxh'),
          dataIndex: 'serialnumber',
          width: 80,
        },
        {
          title: this.$t('translateText.Exam.sjmc'),
          dataIndex: 'examination.strExaminationName',
          ellipsis: true,
          width: 300,
        },
        {
          title: this.$t('translateText.Exam.kssj'),
          dataIndex: 'dtStartTime',
          width: 200,
        },
        {
          title: this.$t('translateText.Exam.jssj'),
          dataIndex: 'dtEndTime',
          width: 200,
        },
        {
          title: this.$t('translateText.Exam.cz'),
          dataIndex: 'op',
          scopedSlots: { customRender: 'op' },
          // width: 300,
        },
      ]
    },
  },
  methods: {
    getdata() {
      this.getpublishedexam()
    },
    //搜索用户
    Searchuser(val) {
      this.strRealName = val
      this.getstudent()
    },
    //点击追加发放标签
    addreceive(row) {
      let nowtime = new Date().getTime()
      if (Date.parse(row.dtEndTime) < nowtime) {
        return this.$message.error(this.$t('translateText.ClassMange.cstx'))
      }
      this.isaddto = true
      this.iExamReleaseId = row.iExamReleaseId
      this.getstudent(row)
    },
    //查询课程中未发布某考试或作业的的用户
    getstudent() {
      let courseid = localStorage.getItem('courseId')
      getStudentByCourse({
        iCourseId: courseid,
        strRealName: this.strRealName,
        iClassId: '0',
        iExamReleaseId: this.iExamReleaseId,
        strUserName: '',
      }).then((response) => {
        if (response.data.iCode == 0) {
          response.data.objData.forEach((item) => {
            this.$set(item, 'key', item.iUserId)
          })
          this.userarr = response.data.objData
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    //从组件中获取到选中的学生信息
    usercheckAll(val) {
      this.selectedusers = val
    },
    // 追加发放确定按钮
    confirm() {
      addtoreleaseExamination({
        listUser: this.selectedusers,
        iExamReleaseId: this.iExamReleaseId,
      }).then((response) => {
        if (response.data.iCode == 0) {
          this.isaddto = false
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    cancel() {
      this.isaddto = false
    },
    compile(row) {
      var a = {
        iExamReleaseId: 0,
        iExaminationId: 0,
        iNumber: 0,
        EndTime: '',
        StartTime: '',
        IsOutOrder: '',
        IsStickUp: '',
        IsViewScore: '',
        iExcellentScore: '',
      }
      a.iExaminationId = row.examination.iExaminationId
      a.iExamReleaseId = row.iExamReleaseId
      a.iNumber = row.ddExamReleaseType.iNumber
      a.EndTime = row.dtEndTime
      a.StartTime = row.dtStartTime
      a.IsOutOrder = row.ddIsOutOrder.iNumber
      a.IsStickUp = row.ddIsStickUp.iNumber
      a.IsViewScore = row.ddIsViewScore.iNumber
      a.iExcellentScore = row.iExcellentScore
      a.iGoodScore = row.iGoodScore
      a.iPassingScore = row.iPassingScore
      sessionStorage.setItem('compiledata', JSON.stringify(a))
      getExaminationInfo({
        iExaminationId: row.examination.iExaminationId,
      }).then((response) => {
        // this.$store.getexaminationinfo(response.data.objData.listQuestion)
        this.$store.commit('getexaminationinfo', response.data.objData)
        this.$router.push({
          path: '/courseContent/Exam/Choosework',
          query: {
            examinationType: '1',
          },
        })
      })
    },

    passpage(pageNumber) {
      this.pageNumber = pageNumber
      this.getpublishedexam()
    },
    //查询所有的试卷
    getexamination() {
      getExamination({
        iCourseId: this.courseid,
        iExaminationType: 0,
        strExaminationName: this.searchKey,
      }).then((response) => {
        if (response.data.iCode == 0) {
          response.data.objData.forEach((item, index) => {
            this.$set(item, 'serialnumber', index + 1)
            this.$set(item, 'key', item.iExaminationId)
          })
          // this.data = response.data.objData.listPage
          this.examinationList = response.data.objData
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    //查询所有已发布考试
    getpublishedexam() {
      getpublishedwork({
        iCourseId: this.courseid,
        iExaminationType: 0,
        strExaminationName: this.searchKey,
        iCurPage: this.pageNumber,
        iPageSize: 10,
      }).then((response) => {
        if (this.$refs.Exampag) {
          this.$nextTick(() => {
            this.$refs.Exampag.showTotal =
              response.data.objData.iTotalPages * 10
            this.$refs.Exampag.pageNumber = response.data.objData.iPageIndex
          })
        }
        sessionStorage.setItem(
          'showTotal',
          response.data.objData.iTotalPages * 10
        )
        sessionStorage.setItem('pageNumber', response.data.objData.iPageIndex)
        response.data.objData.listPage.forEach((item, index) => {
          item.dtEndTime = moment(item.dtEndTime).format('YYYY-MM-DD HH:mm')
          item.dtStartTime = moment(item.dtStartTime).format('YYYY-MM-DD HH:mm')
          this.$set(item, 'serialnumber', index + 1)
          this.$set(item, 'key', item.iExamReleaseId)
        })
        this.data = response.data.objData.listPage
      })
    },
    //全选
    checkAll(val) {
      this.selectedRowKeys = val
    },
    AddTest() {
      //新建试卷
      // this.colorNew = false;
      this.$router.push({
        path: '/courseContent/Exam/AddExamination',
        query: {
          examinationType: 0,
        },
      })
    },
    cancelFn() {
      this.svisible = false
    },
    confirmFn() {
      this.svisible = false
      // this.colorDel = false;
      this.deleteexamination()
    },
    deleteexamination() {
      let arr2 = this.selectedRowKeys.map((item) => {
        return Object.assign({}, { iExamReleaseId: item })
      })
      deleteExaminationRelease(arr2).then((response) => {
        var pageNum = this.$refs.Exampag.showTotal / 10
        if (pageNum == this.pageNumber && this.data.length == arr2.length) {
          this.pageNumber--
          if (this.pageNumber == 0) {
            this.pageNumber = 1
          }
        }
        if (response.data.iCode == 0) {
          this.getpublishedexam()
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    delFn() {
      if (this.selectedRowKeys.length == 0) {
        return this.$message.error(this.$t('translateText.Exam.qdwxz'))
      }
      this.svisible = true
      this.color = true
    },
    del(item) {
      this.selectedRowKeys = [item.iExamReleaseId]
      this.deleteexamination()
    },
    //新建试卷
    addExam() {
      this.isadd = true
      this.addExamDiv = true
      // this.colorAdd = true;
    },
    handleCancel() {
      this.addExamDiv = false
      // this.colorAdd = false;
      this.showExamList = true
      this.showAddExamUser = false
      this.addExamDivTitle = this.$t('translateText.ExamMsg.sjk')
      this.addExamDivOkText = this.$t('translateText.ExamMsg.xyb')
      this.addExamDivCancelText = this.$t('translateText.ExamMsg.qx')
      this.$refs.selectExamination.clear()
      this.$refs.selectuser.clear()
      this.examinationIdList = []
      this.receiveIdList = []
      this.$refs.selectuser.startValue = ''
      this.$refs.selectuser.endValue = ''
    },
    cancelButton(e) {
      this.$refs.selectExamination.clear()
      this.$refs.selectuser.clear()
      this.examinationIdList = []
      this.receiveIdList = []
      this.$refs.selectuser.startValue = ''
      this.$refs.selectuser.endValue = ''
      if (this.showExamList) {
        this.addExamDiv = false
        // this.colorAdd = false;
      } else {
        if (e.currentTarget.innerHTML.trim() == this.$t('translateText.ExamMsg.qx')) {
          this.addExamDiv = false
        }
        this.showExamList = true
        this.showAddExamUser = false
        this.addExamDivTitle = this.$t('translateText.ExamMsg.sjk')
        this.addExamDivOkText = this.$t('translateText.ExamMsg.xyb')
        this.addExamDivCancelText = this.$t('translateText.ExamMsg.qx')
      }
    },
    okButton() {
      this.starttime = this.$refs.selectuser.startValue, //开始时间
        this.endtime = this.$refs.selectuser.endValue, //结束时间
        this.passingscore = this.$refs.selectuser.passingScore, //及格分数线
        this.goodscore = this.$refs.selectuser.goodScore, //良好分数线
        this.excellentscore = this.$refs.selectuser.excellentScore, //优秀分数线
        this.stickup = this.$refs.selectuser.isStickUp ? 1 : 0, //是否允许粘贴
        this.outorder = this.$refs.selectuser.isOutOrder ? 1 : 0, //是否乱序
        this.viewscore = this.$refs.selectuser.isViewScore ? 1 : 0 //学生是否可看成绩
      if (this.showExamList) {
        this.$refs.selectuser.iseliminate = true
        if (this.examinationIdList.length == 0) {
          return this.$message.error(this.$t('translateText.ExamMsg.xzzy'))
        }
        this.addExamDivTitle = this.$t('translateText.ExamMsg.fbdx')
        this.addExamDivOkText = this.$t('translateText.ExamMsg.fb')
        this.addExamDivCancelText = this.$t('translateText.ExamMsg.syb')
        this.showExamList = false
        this.showAddExamUser = true
      } else {
        this.$refs.selectuser.getSetData()
        if (this.examinationRelease != null) {
          for (let i = 0; i < this.data.length; i++) {
            for (let j = 0; j < this.examinationIdList.length; j++) {
              if (
                this.data[i].examination.iExaminationId ==
                this.examinationIdList[j].iExaminationId
              ) {
                return this.$message.error(this.$t('translateText.ExamMsg.bncf'))
              }
            }
          }
          if (this.releaseobj.length == 0) {
            return this.$message.error(this.$t('translateText.ExamMsg.bxxz'))
          }
          if (this.isadd) {
            if (this.releasetype == 0) {
              releaseExamination({
                dtStartTime: moment(this.starttime).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
                iPassingScore: this.passingscore,
                iGoodScore: this.goodscore,
                iExcellentScore: this.excellentscore,
                isStickUp: this.stickup,
                isOutOrder: this.outorder,
                isViewScore: this.viewscore,
                iExamReleaseType: this.releasetype,
                listExamination: this.examinationIdList,
                listUserClass: this.releaseobj,
              }).then((response) => {
                if (response.data.iCode == 0) {
                  this.addExamDiv = false
                  this.getpublishedexam()
                  this.selectedRowKeys = []
                  this.$refs.selectExamination.selectedRowKeys = []
                  this.examinationIdList = ''
                  this.showHomeWorkList = true
                  this.showAddHomeWorkUser = false
                  this.addHomeWorkDivTitle = this.$t('translateText.ExamMsg.zyk')
                  this.addHomeWorkDivOkText = this.$t('translateText.ExamMsg.xyb')
                  this.addHomeWorkDivCancelText = this.$t('translateText.ExamMsg.qx')
                  this.$refs.selectuser.startValue = ''
                  this.$refs.selectuser.endValue = ''
                  this.$refs.selectuser.passingScore = 60
                  this.$refs.selectuser.goodScore = 75
                  this.$refs.selectuser.excellentScore = 90
                  this.$refs.selectuser.isViewScore = true
                  this.$refs.selectuser.isOutOrder = true
                  this.$refs.selectuser.isStickUp = true
                  this.$refs.selectExamination.clear()
                  this.$refs.selectuser.clear()
                  this.examinationIdList = []
                  this.receiveIdList = []
                  this.$refs.selectuser.startValue = ''
                  this.$refs.selectuser.endValue = ''
                } else {
                  return this.$message.error(response.data.strMessage)
                }
              })
            }
            if (this.releasetype == 1) {
              releaseExamination({
                dtStartTime: moment(this.starttime).format(
                  'YYYY-MM-DD HH:mm:ss'
                ),
                dtEndTime: moment(this.endtime).format('YYYY-MM-DD HH:mm:ss'),
                iPassingScore: this.passingscore,
                iGoodScore: this.goodscore,
                iExcellentScore: this.excellentscore,
                isStickUp: this.stickup,
                isOutOrder: this.outorder,
                isViewScore: this.viewscore,
                iExamReleaseType: this.releasetype,
                listExamination: this.examinationIdList,
                listUser: this.releaseobj,
              }).then((response) => {
                if (response.data.iCode == 0) {
                  this.addExamDiv = false
                  // this.colorAdd = false;
                  this.getpublishedexam()
                  this.selectedRowKeys = []
                  this.$refs.selectExamination.selectedRowKeys = []
                  this.examinationIdList = ''
                  this.showHomeWorkList = true
                  this.showAddHomeWorkUser = false
                  this.addHomeWorkDivTitle = this.$t('translateText.ExamMsg.zyk')
                  this.addHomeWorkDivOkText = this.$t('translateText.ExamMsg.xyb')
                  this.addHomeWorkDivCancelText = this.$t('translateText.ExamMsg.qx')
                  this.$refs.selectuser.startValue = ''
                  this.$refs.selectuser.endValue = ''
                  this.$refs.selectuser.passingScore = 60
                  this.$refs.selectuser.goodScore = 75
                  this.$refs.selectuser.excellentScore = 90
                  this.$refs.selectuser.isViewScore = true
                  this.$refs.selectuser.isOutOrder = true
                  this.$refs.selectuser.isStickUp = true
                  this.$refs.selectExamination.clear()
                  this.$refs.selectuser.clear()
                  this.examinationIdList = []
                  this.receiveIdList = []
                  this.$refs.selectuser.startValue = ''
                  this.$refs.selectuser.endValue = ''
                } else {
                  return this.$message.error(response.data.strMessage)
                }
              })
            }
          }
        }
      }
    },
    //数组去重
    unique(arr) {
      const res = new Map()
      return arr.filter(
        (arr) => !res.has(arr.iClassId) && res.set(arr.iClassId, 1)
      )
    },
    //打开提交详情页
    openSubmitDetails(row) {
      this.$store.commit('getexamrelease', row)
      this.$router.push('/courseContent/SubmitDetails')
    },
    //获取选中的试卷
    getExaminationId(selectedRowKeys) {
      this.examinationIdList = selectedRowKeys.map((item) => {
        return Object.assign({}, { iExaminationId: item })
      })
    },
    //获取试卷发布设置
    getExaminationRelease(examinationRelease) {
      this.examinationRelease = examinationRelease
    },
    //获取选中的用户或班级
    getReceiveList(val, type) {
      this.releasetype = type
      if (type == 0) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iClassId: item })
        })
      } else if (type == 1) {
        this.releaseobj = val.map((item) => {
          return Object.assign({}, { iUserId: item })
        })
      }
    },
    //搜索试卷
    onSearch(val) {
      this.pageNumber = 1
      this.searchKey = val
      this.getpublishedexam()
    },
    zero() {
      this.searchKey = ''
    },
    searchuser(val) {
      var vm = this
      getExamination({
        iCourseId: 1,
        iExaminationType: 1,
        strExaminationName: val,
        iCurPage: 1,
        iPageSize: 10,
      }).then(function(response) {
        if (response.status == 200) {
          if (response.data.objData.length > 0) {
            vm.data = response.data.objData.listPage
            //vm.show = response.data.objData.listPage;
            return this.$message.success(`已搜索到${vm.data.length}个考试`)
          } else {
            vm.data = []
            return vm.$message.error(`暂未搜索到相关考试`)
          }
        }
      })
    },
  },
  components: {
    search,
    pag,
    sModal,
    test,
    selectExamination,
    selectUser,
  },
  // computed: {

  // },
}
</script>

<style lang="less" scoped>
&/deep/ .ant-table-tbody > tr > td:last-child {
  padding: 10px 10px;
}
.examinationTable {
  border: 12px solid #000;
  margin-top: 10px;
  padding: 10px;
  border: solid 1px #a9a9a9;
  height: 300px;
  overflow: auto;
}
#exam {
  height: 100%;
  width: 100%;
  padding: 0 3% 0 2%;
}
.nav-header {
  right: 2%;
  left: 2%;
  height: 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background-color: #ff6700;
  border-bottom: 2px solid #d5d5d5;
  margin-bottom: 1%;
  position: absolute;
  top: 0;
}
.nav-body {
  position: absolute;
  top: 10%;
  right: 2%;
  left: 2%;
  // bottom: 6%;
  bottom: 48px;
  overflow: auto;
}
.nav-body::-webkit-scrollbar {
  display: none;
}
.addExamDivTitle {
  line-height: 0;
  color: #4e4e4e;
  text-align: center;
  font-weight: 700;
}

.addExamDivFooter {
  text-align: center;
  margin-top: 10px;
}

.addExamDivFooter button {
  margin: 0 20px;
  padding: 5px 15px;
  background-color: #fff;
  border: solid 1px #7c838d;
  border-radius: 3px;
  color: #7c838d;
}

.addExamDivFooter .okButton {
  background-color: #2eadb5;
  border: none;
  color: #fff;
}
/deep/.ant-table-body::-webkit-scrollbar {
  display: none;
}
</style>
